import axios from './HttpRequestCustomerApp';


    function getProvince(){
        return axios.get('/web/location/province');
    }

    function getDistrict(provinceId){
        return axios.get('/web/location/district?provinceId='+provinceId);
    }

    function getWard(districtId){
        return axios.get('/web/location/ward?districtId='+districtId);
    }
    export {getProvince,getDistrict,getWard}